import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {SelectedDataReceivedStatusType} from "../../Filters/utils";
import {selectedDataReceivedSelectorMonitoring, setSelectedDataReceivedMonitoring} from "../Selectors/filtersSliceMonitoring";

export const useSelectedDataReceivedMonitoring = () => {
    const dispatch = useDispatch();
    const dataReceived = useSelector(selectedDataReceivedSelectorMonitoring);

    const onSelectDataReceived = React.useCallback((selected: SelectedDataReceivedStatusType) => {
        dispatch(setSelectedDataReceivedMonitoring(selected));
    }, [dispatch]);

    return {
        dataReceived,
        onSelectDataReceived,
    };
};